import { AppFilesService } from "./appFilesService"
import { AppSession } from "./appSession"
import { IAppFiles, IAppOrganisation, IFolderContent, IStorageBoundariesSource, StorageBrowserState } from "./types"

export function createFilesInterface(session: AppSession, fileSvc: AppFilesService) {

    return new AppFiles(
        fileSvc,
        session.connectionId,
        session.app.name,
        session.app.storage?.canSelectFolders,
        () => session.connected,
        () => session.hasOrganisations,
        () => session.getDefaultOrganisation()
    )

}

export class AppFiles implements IAppFiles {

    public readonly cache = new Map<string, IFolderContent>()

    constructor(
        private fileSvc: AppFilesService,
        public readonly connectionId: string,
        public readonly name: string,
        public readonly canSelectFolders: boolean,
        private readonly _connected: () => boolean,
        private readonly _hasOrganisations: () => boolean,
        public readonly getDefaultOrganisation: () => IAppOrganisation
    ) {

        const cache = fileSvc.getConnectionState(connectionId)?.cache
        this.cache = cache ?? this.cache

    }

    get connected() {
        return this._connected()
    }

    get hasOrganisations() {
        return this._hasOrganisations()
    }

    refresh() {
        this.cache.clear()
    }

    getBoundariesSources(holdingId: number): ng.IPromise<IStorageBoundariesSource[]> {
        return this.fileSvc.getBoundariesSources(this.connectionId, holdingId);
    }

    getFolderContent(path: string): ng.IPromise<IFolderContent> {
        return this.fileSvc.getFolderContent(this, path)
    }

    getConnectionState() {
        return this.fileSvc.getConnectionState(this.connectionId)?.browser
    }

    setConnectionState(state: StorageBrowserState) {
        this.fileSvc.setConnectionState(this.connectionId, { browser: state, cache: this.cache })
    }

}

export function normalizePath(path: string): string {
    return path && path.length > 1 && path[path.length - 1] === '/' ? path.substr(0, path.length - 1) : path;
}
